import { type TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { DialogContent, Link, Stack } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { MyShiftCard } from "@src/appV2/redesign/Shift/Card/MyShiftCard";
import {
  BottomSheet,
  DialogFooter,
  Illustration,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

import { LoadingButton } from "../../components/LoadingButton";

export interface RegularShiftBookedBottomSheetProps {
  modalState: UseModalState;
  onWorkplaceActionClick: () => void;
  workplaceActionLabel: string;
  isWorkplaceActionLoading: boolean;
  shiftStartIso: string;
  shiftEndIso: string;
  shiftTimeSlot: TimeSlot;
  workplaceName: string;
  workplaceTimezone: string | undefined;
  shiftHourlyPay: string | undefined;
  shiftFormattedTotalPay: string | undefined;
  shiftTotalPay: number | undefined;
  shiftBoost: number | undefined;
  requiresBreak: boolean | undefined;
  breakDurationInMinutes: number;
  isLoadingQualification: boolean;
  qualificationText: string;
}

export function RegularShiftBookedBottomSheet(props: RegularShiftBookedBottomSheetProps) {
  const {
    modalState,
    onWorkplaceActionClick,
    workplaceActionLabel,
    isWorkplaceActionLoading,
    shiftStartIso,
    shiftEndIso,
    shiftTimeSlot,
    workplaceName,
    workplaceTimezone,
    shiftHourlyPay,
    shiftFormattedTotalPay,
    shiftTotalPay,
    shiftBoost,
    requiresBreak,
    breakDurationInMinutes,
    isLoadingQualification,
    qualificationText,
  } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={
        <BottomSheetHeader
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
      footer={
        <DialogFooter orientation="vertical" LinkComponent={Link}>
          <LoadingButton
            fullWidth
            variant="contained"
            size="large"
            isLoading={isWorkplaceActionLoading}
            onClick={() => {
              onWorkplaceActionClick();
            }}
          >
            {workplaceActionLabel}
          </LoadingButton>
        </DialogFooter>
      }
    >
      <DialogContent sx={{ backgroundColor: "unset" }}>
        <Stack direction="column" alignItems="center" spacing={9}>
          <Illustration type="shift-booked" />
          <Title variant="h2" component="h2" sx={{ textAlign: "center", width: "14rem" }}>
            Your shift is booked!
          </Title>
          <MyShiftCard
            outlined
            shiftStart={shiftStartIso}
            shiftEnd={shiftEndIso}
            shiftTimeSlot={shiftTimeSlot}
            workplaceName={workplaceName}
            workplaceTimezone={workplaceTimezone}
            shiftHourlyPay={shiftHourlyPay}
            shiftFormattedTotalPay={shiftFormattedTotalPay}
            shiftTotalPay={shiftTotalPay}
            shiftBoost={shiftBoost}
            requiresBreak={requiresBreak}
            breakDurationInMinutes={breakDurationInMinutes}
            isLoadingQualification={isLoadingQualification}
            qualificationText={qualificationText}
          />
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
